<div class="basket-list-item-container">
  <div class="content" *ngIf="entry.product as product">
    <a [customRouterLink]="productLink" class="first">
      <div class="article">
        <div class="image" *ngIf="product.images[0] as image">
          <img
            [lazyLoad]="image.url + '?width=140&height=140&padColor=fff'"
            [defaultImage]="image.url + '?width=50&height=50&padColor=fff'"
            errorImage="./assets/ui/shared/error/not_found_error_image.png"
            [alt]="image.altText"
            [title]="image.titleText || image.altText"
            src="#"
          />
        </div>
        <div class="info">
          <div class="title">{{ product.name }}</div>
          <div class="features">
            <p *ngFor="let category of product.categories"> {{ category.formattedName }} </p>
            <p *ngIf="isContract"> {{ 'basket.item.contract' | translate }} </p>
          </div>
          <div class="article-number"> {{ 'basket.item.articleNumber' | translate }} {{ product.code }} </div>
          <div class="delivery">
            <div class="hub-info {{ product.stock?.stockLevelStatus === 'inStock' ? 'inStock' :  'noStock'}}">
              <ng-container
                *ngIf="product.stock?.stockLevelStatus === 'inStock'; else noStock">{{ 'basket.item.stock.inStock' | translate }}</ng-container>
              <ng-template #noStock> {{ 'basket.item.stock.notInStock' | translate }} </ng-template>
            </div>
            <div class="days">
              <kion-delivery-time [product]="product"></kion-delivery-time>
            </div>
          </div>
        </div>
      </div>
    </a>
   <div class="middle">
     <div class="unit-price" *ngIf="product.price as price">
       <div>
         <span>{{ 'basket.item.price.unitPrice' | translate }}</span>
         <kion-price [price]="getNettoPrice(price)" [strikedPrice]="getNettoStrikedPrice(price)" type="medium"></kion-price>
       </div>
       <div class="price" *ngIf="entry.totalPrice as price">
         <span>{{ 'basket.item.price.totalPrice' | translate }}</span>
         <kion-price [price]="price.formattedValue" type="medium"></kion-price>
       </div>
     </div>
     <div class="quantity" [formGroup]="form">
       <p *ngIf="!editable"><b>{{ entry.quantity }}</b></p>
       <kion-quantity-selector [actualValue]="entry.quantity" [formGroup]="form" (changed)="quantityChanged($event)" *ngIf="editable"></kion-quantity-selector>
       <div class="btn-delete" [hidden]="!editable">
         <kion-label-button [title]="'basket.item.button.delete' | translate" (click)="delete()">
           <svg img xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
             <path fill="#9B9B9E" fill-rule="evenodd" d="M13.3 0l1.429 2.857h4.557v1.429h-1.429L16.43 20H3.57L2.143 4.286H.714V2.857h4.557L6.7 0h6.6zm3.129 4.286H3.57L5 18.57h10l1.429-14.285zM7.857 7.143v8.571H6.43V7.143h1.428zm2.857 0v8.571H9.286V7.143h1.428zm2.857 0v8.571h-1.428V7.143h1.428zm-1.157-5.714H7.586L6.87 2.857h6.258l-.715-1.428z"/>
           </svg>
         </kion-label-button>
       </div>
     </div>
   </div>
    <div class="last">
      <div class="price" *ngIf="entry.totalPrice as price">
        <kion-price [price]="price.formattedValue" type="medium"></kion-price>
      </div>
    </div>
  </div>
</div>
